import { render } from "./Params.vue?vue&type=template&id=4eb4f9fd"
import script from "./Params.vue?vue&type=script&lang=js"
export * from "./Params.vue?vue&type=script&lang=js"
script.render = render

export default script